import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ModulesApi from '../generated/api/Modules';

export default (service: Servicelayer) => ({
  ...ModulesApi(service),

  // Add custom calls here

});
